var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.5c.631 0 1.143.512 1.143 1.143l-.001 5.714h5.715a1.143 1.143 0 110 2.286l-5.715-.001v5.715a1.143 1.143 0 11-2.285 0v-5.715H5.643a1.143 1.143 0 110-2.285h5.714V5.643c0-.631.512-1.143 1.143-1.143z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 2.25,
    cx: 12.5,
    cy: 12.5,
    r: 11.375
  }))));
}

export default SvgCommonIconPlusCircle;